<template>
  <roe-chart-table-switch
    name="Paycheck Impact for Participants"
    v-if="currentDesigns.length > 0"
  >
    <template #chartView>
      <div class="table paycheck-table">
        <div class="table-row">
          <div class="table-unit table-desc-unit">
            Percent impacted
            <div class="light-label">Percent / Number of participants</div>
            <div class="select-wrap">
              <input type="text" />
            </div>
          </div>
          <div class="table-unit"></div>
          <div class="table-unit" v-for="(design, index) in currentDesigns">
            <roe-pie
              :value="design.paycheck_impact.percent_impacted"
              :label="design.paycheck_impact.number_impacted"
              :color="designColors[index + 1]"
            ></roe-pie>
          </div>
        </div>
        <div
          class="table-row"
          v-for="(segment,
          index) in originalDesign.paycheck_segments.slice().reverse()"
        >
          <div class="table-unit table-desc-unit">
            <template v-if="index === 0">
              Paycheck Reduction of Percent Impacted
              <div class="light-label">Percent / Number of participants</div>
            </template>
          </div>
          <div class="table-unit">
            <template v-if="index === 0">
              > {{ segment.from | currency({ fractionCount: 0 }) }}
            </template>
            <template v-else>
              {{ segment.from | currency({ fractionCount: 0 }) }}-{{
                segment.to | currency({ fractionCount: 0 })
              }}
            </template>
          </div>
          <div
            class="table-unit table-graph-unit"
            v-for="(design, i) in currentDesigns"
          >
            <roe-horizontal-bar
              :value="barPercentImpacted(design, index)"
              :number="numberImpacted(design, index)"
              :price="difference(design, index)"
              :color="designColorClasses[i + 1]"
            ></roe-horizontal-bar>
          </div>
        </div>

        <div class="table-row table-row-total">
          <div class="table-unit table-desc-unit">Total Impact</div>
          <div class="table-unit"></div>
          <div class="table-unit" v-for="design in currentDesigns">
            <h2>
              {{
                design.paycheck_impact.total_difference
                  | currency({ fractionCount: 0 })
              }}
            </h2>
          </div>
        </div>
      </div>
    </template>

    <template #tableView>
      <div class="table paycheck-table paycheck-table--text">
        <div class="table-row">
          <div class="table-unit table-desc-unit">
            Percent impacted
            <div class="light-label">Percent / Number of participants</div>
            <div class="select-wrap">
              <input type="text" />
            </div>
          </div>
          <div class="table-unit"></div>
          <div class="table-unit" v-for="(design, index) in currentDesigns">
            <div
              class="table-header-participants"
              :class="'plan-header-' + designColorClasses[index + 1]"
            >
              <h2>
                {{ design.paycheck_impact.percent_impacted | percentage }}
                <div class="common-light-label">
                  {{ design.paycheck_impact.number_impacted }} participants
                </div>
              </h2>
            </div>
          </div>
        </div>
        <div
          class="table-row"
          v-for="(segment,
          index) in originalDesign.paycheck_segments.slice().reverse()"
        >
          <div class="table-unit table-desc-unit">
            <template v-if="index === 0">
              Paycheck Reduction of Percent Impacted
              <div class="light-label">Percent / Number of participants</div>
            </template>
          </div>
          <div class="table-unit">
            <template v-if="index === 0">
              > {{ segment.from | currency({ fractionCount: 0 }) }}
            </template>
            <template v-else>
              {{ segment.from | currency({ fractionCount: 0 }) }}-{{
                segment.to | currency({ fractionCount: 0 })
              }}
            </template>
          </div>
          <div
            class="table-unit table-unit--border-bottom"
            v-for="design in currentDesigns"
          >
            <div class="participants-desc">
              <div class="common-light-label">
                {{ numberImpacted(design, index) }}
              </div>
              <div>
                {{ difference(design, index) | currency({ fractionCount: 0 }) }}
              </div>
            </div>
          </div>
        </div>
        <div class="table-row table-row-total">
          <div class="table-unit table-desc-unit">Total Impact</div>
          <div class="table-unit"></div>
          <div class="table-unit" v-for="design in currentDesigns">
            <h2>
              {{
                design.paycheck_impact.total_difference
                  | currency({ fractionCount: 0 })
              }}
            </h2>
          </div>
        </div>
      </div>
    </template>
  </roe-chart-table-switch>
</template>

<script>
import RoePie from "@/components/charts/Pie";
import RoeHorizontalBar from "@/components/charts/HorizontalBar";
import RoeChartTableSwitch from "@/components/alternative-designs/_shared/ChartTableSwitch";
import { mapGetters } from "vuex";

export default {
  name: "RoePaycheckImpact",
  computed: {
    ...mapGetters([
      "designColors",
      "designColorClasses",
      "originalDesign",
      "currentDesigns"
    ]),
    maxParticipantNumber() {
      return Math.max(
        ...this.currentDesigns.map(d =>
          Math.max(...d.paycheck_segments.map(c => +c.number_impacted || 0))
        )
      );
    }
  },
  methods: {
    numberImpacted(design, index) {
      return (
        +design.paycheck_segments.slice().reverse()[index]
          .number_impacted || 0
      );
    },
    difference(design, index) {
      return (
        +design.paycheck_segments.slice().reverse()[index].difference || 0
      );
    },
    barPercentImpacted(design, index) {
      if (this.maxParticipantNumber === 0) return 0;
      return this.numberImpacted(design, index) / this.maxParticipantNumber;
    }
  },
  components: {
    RoePie,
    RoeHorizontalBar,
    RoeChartTableSwitch
  }
};
</script>
